import {
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_BEGIN,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_SUCCESS,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_FAILURE,
  DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function updateCollectionWithXata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_SUCCESS,
            data: res,
          });
          toast.success('Collection Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: to Update Collection`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionWithXataError() {
  return {
    type: DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_BEGIN:
      return {
        ...state,
        updateCollectionWithXataPending: true,
        updateCollectionWithXataError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_SUCCESS:
      return {
        ...state,
        updateCollectionWithXataPending: false,
        updateCollectionWithXataError: null,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_FAILURE:
      return {
        ...state,
        updateCollectionWithXataPending: false,
        updateCollectionWithXataError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_COLLECTION_WITH_XATA_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionWithXataError: null,
      };

    default:
      return state;
  }
}
